import { Check } from "lucide-react";
import type { TeamPaymentStatus } from "@/api/payments";

const config: Record<
  Exclude<TeamPaymentStatus, null>,
  { label: string; className: string; icon?: true }
> = {
  paid: {
    label: "Paid",
    className:
      "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300",
    icon: true,
  },
  partial: {
    label: "Partial",
    className:
      "bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300",
  },
  unpaid: {
    label: "Unpaid",
    className:
      "bg-[hsl(6_74%_93%)] text-[hsl(6_74%_40%)] dark:bg-[hsl(6_50%_15%)] dark:text-[hsl(6_60%_65%)]",
  },
  free: {
    label: "Free",
    className: "bg-primary/10 text-primary",
  },
};

export function PaymentStatusPill({
  status,
}: {
  status: TeamPaymentStatus;
}) {
  if (!status) {
    return null;
  }
  const c = config[status];
  // payment_status is a TEXT column; guard against values outside the union
  // (legacy/unexpected) so an undefined config entry can't crash rendering.
  if (!c) {
    return null;
  }
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${c.className}`}
    >
      {c.icon && <Check className="h-3 w-3" />}
      {c.label}
    </span>
  );
}
